import { all } from "redux-saga/effects"
import { loginSaga } from "./auth/loginSaga"
import { authSaga } from "./auth/authSaga"
import { userSaga } from "./auth/userSaga"
import { subSystemSaga } from "./sub-system/subSytemSaga"
import { truongSaga } from "./category/truongSaga"
import { khoiSaga } from "./category/khoiSaga"
import { heSaga } from "./category/heSaga"
import { monHocSaga } from "./category/monHocSaga"
import { roleSaga } from "./auth/roleSaga"
import { appConfigSaga } from "./common/appConfigApiSaga"

export default function* rootSaga() {
    yield all([
        authSaga(),
        loginSaga(),
        userSaga(),
        subSystemSaga(),
        truongSaga(),
        khoiSaga(),
        heSaga(),
        monHocSaga(),
        roleSaga(),
        appConfigSaga()
    ])


}
